






































































import { Component, Vue } from "vue-property-decorator";
import Navigation from "@/components/Navigation.vue"; // @ is an alias to /src
import Header from "@/components/Header.vue";
import Portfolio from "@/components/Portfolio.vue";
import About from "@/components/About.vue";
import Contact from "@/components/Contact.vue";
import Footer from "@/components/Footer.vue";

import TweetPolitik from "@/components/projects/TweetPolitik.vue";

@Component({
  components: {
    Navigation,
    Header,
    Portfolio,
    About,
    Contact,
    Footer,
    tweetPolitik: TweetPolitik
  }
})
export default class Home extends Vue {
  
}
